import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import ProductsListPage from "./ProductsListPage";

const ExportCommodities = () => {
  const { t, lang } = useI18n();
  const titles = {
    en: { title: "Export Commodities", sub: "Premium-grade commodities sourced from verified producers across Indonesia and Southeast Asia." },
    tr: { title: "İhracat Ürünleri", sub: "Endonezya ve Güneydoğu Asya'daki doğrulanmış üreticilerden tedarik edilen premium ürünler." },
    id: { title: "Komoditas Ekspor", sub: "Komoditas kualitas premium dari produsen terverifikasi di Indonesia dan Asia Tenggara." },
  }[lang] || {};
  return <ProductsListPage type="export" eyebrow="Export" title={titles.title} subtitle={titles.sub} />;
};

export default ExportCommodities;
